import { __assign, __rest } from "tslib";
import React from 'react';
import { Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, } from '@chakra-ui/react';
var PopoverComponent = function (_a) {
    var title = _a.title, hideCloseButton = _a.hideCloseButton, target = _a.target, children = _a.children, contentProps = _a.contentProps, props = __rest(_a, ["title", "hideCloseButton", "target", "children", "contentProps"]);
    return (React.createElement(Popover, __assign({ returnFocusOnClose: false, placement: 'auto', closeOnBlur: true }, props),
        React.createElement(PopoverTrigger, null, target),
        React.createElement(PopoverContent, __assign({ color: 'text.default' }, contentProps),
            title && React.createElement(PopoverHeader, { fontWeight: 'semibold' }, title),
            React.createElement(PopoverArrow, null),
            !hideCloseButton && React.createElement(PopoverCloseButton, null),
            React.createElement(PopoverBody, null, children))));
};
export default PopoverComponent;
//# sourceMappingURL=PopOver.js.map